import { createContext } from "react";

export const NonceContext = createContext("");
